export default {
  color: {}
}
